<template>
	<main-page :user="user" color="blue">
		<template v-slot:title> </template>

		<div class="container-fluid" style="text-align: left;">
			<div class="row mt-3">
				<div class="col-sm-3">
					<admin-nav></admin-nav>
				</div>

				<div class="col-sm-9">
					<div class="mx-auto card p-4">
						<h1 class="text-center">Admin Console</h1>
						<div class="text-md text-center text-muted">Use the options to the left to navigate</div>
					</div>
				</div>
			</div>
		</div>
	</main-page>
</template>

<script>
import MainPage from "@/components/MainPage";
import AuthService from "@/services/AuthService";
import AdminNav from "@/vues/admin/AdminNav";

export default {
	name: "AdminLanding",

	props: ["user"],

	components: { MainPage, AdminNav },

	data() {
		return {
			username: "",
			password: "",

			goingToGoogle: false,
		};
	},

	methods: {
		login() {
			AuthService.login(this.username, this.password).then((user) => {
				// debugger;
				console.log(user);
				if (user.role == "ADMIN") {
					this.$router.push("/admin");
				} else {
					this.$router.push("/portfolio");
				}
			});
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
